import { Activity, Film, Zap } from "lucide-react";

const PILLAR_META = {
  availability: { Icon: Activity, label: "Availability", color: "#10b981", subtitle: "Sports Medicine" },
  development:  { Icon: Film,     label: "Development",  color: "#3b82f6", subtitle: "Biomechanics" },
  performance:  { Icon: Zap,      label: "Performance",  color: "#f59e0b", subtitle: "Outcome quality" },
};

const BAND_COLORS = {
  ready:   { bg: "rgba(16,185,129,0.12)", border: "rgba(16,185,129,0.4)", text: "#34d399", label: "READY" },
  caution: { bg: "rgba(245,158,11,0.12)", border: "rgba(245,158,11,0.4)", text: "#fbbf24", label: "CAUTION" },
  hold:    { bg: "rgba(239,68,68,0.12)",  border: "rgba(239,68,68,0.45)", text: "#fca5a5", label: "HOLD" },
};

/**
 * DepartmentPills — compact 3-pillar summary chip cluster.
 * Used inline on the Coach Roster row (no labels, just colored score chips)
 * and on the Player Detail / /department deep-view (with labels).
 */
export default function DepartmentPills({ verdict, compact = false, testId = "dept-pills" }) {
  if (!verdict?.pillars) {
    return (
      <span className="text-[10px] text-white/35 uppercase tracking-wider" data-testid={`${testId}-empty`}>—</span>
    );
  }
  const order = ["availability", "development", "performance"];
  return (
    <div className={`inline-flex items-center gap-1.5 ${compact ? "" : "flex-wrap"}`} data-testid={testId}>
      {order.map((k) => {
        const p = verdict.pillars[k];
        const meta = PILLAR_META[k];
        const band = BAND_COLORS[p?.band] || BAND_COLORS.hold;
        const Icon = meta.Icon;
        return (
          <span
            key={k}
            title={`${meta.label} · ${Math.round(p?.score || 0)} · ${band.label}`}
            className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md text-[10px] font-bold border`}
            style={{ backgroundColor: band.bg, borderColor: band.border, color: band.text }}
            data-testid={`${testId}-${k}`}
          >
            <Icon className="h-3 w-3" />
            {compact ? Math.round(p?.score || 0) : `${meta.label} ${Math.round(p?.score || 0)}`}
          </span>
        );
      })}
      <OverallChip band={verdict.overall_band} score={verdict.overall_score} testId={`${testId}-overall`} />
    </div>
  );
}

function OverallChip({ band, score, testId }) {
  const c = BAND_COLORS[band] || BAND_COLORS.hold;
  return (
    <span
      className="inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-bold border"
      style={{ backgroundColor: c.bg, borderColor: c.border, color: c.text }}
      data-testid={testId}
    >
      {c.label} · {Math.round(score || 0)}
    </span>
  );
}

export { PILLAR_META, BAND_COLORS };
